'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import teamActions from 'actions/TeamActionCreators';
import teamStore from 'stores/TeamStore';
import PageSection from 'components/base/PageSection';
import List from 'components/base/list-components/List';
import ListItem from 'components/base/list-components/ListItem';
import ListSection from 'components/base/list-components/ListSection';

import _ from 'underscore';
import utils from 'services/utils';
import personUtils from 'services/people/personUtils';
import constants from 'constants/appConstants';
import moment from 'moment';

const propTypes = {
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class ManagementTeamWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        var hide = true;
        var content = "";
        var managementTeams = [];
        var maxRows = 4;

        var teams = personUtils.getTeams(constants.ENUMS.ROLE_TYPES.MANAGER, this.props.person.Memberships);
       
        _.map(teams, function (team, index) {
            managementTeams.push( <ListItem key={index} heading={team.Name} link={"/teams/team/" + team.Id + "/"} />);
        });


        if (managementTeams.length > 0) {

            hide = null;
            content = ( 
                <List icon="icon-management-teams" id={this.props.id} heading="Management Teams" link={"/teams/"}>
                    <ListSection maxItems={maxRows} moreLink={"/teams/"}>
                        {managementTeams}
                    </ListSection>
                </List>
            );
        } else {
            hide = true;
        }

        return (
            <PageSection
                id="management-team-widget"
                hideSection={hide}
                maxItems={maxRows}
            >
                {content}
            </PageSection>
        );
    }
}

ManagementTeamWidget.propTypes = propTypes;

export default ManagementTeamWidget; 